import type { ExperienceTrackerAPI } from '@confluence/experience-tracker/entry-points/ExperienceTracker.ts';

export const recordSuccess = (
	experienceTracker: ExperienceTrackerAPI,
	experienceName?: string,
): void => {
	if (experienceName) {
		experienceTracker.succeed({ name: experienceName });
	}
};

export const getRecordFailure = (
	experienceTracker: ExperienceTrackerAPI,
	experienceName?: string,
) => {
	return (errorMsg: string | undefined): void => {
		if (experienceName) {
			experienceTracker.fail({
				name: experienceName,
				error: new Error(errorMsg || 'Error rendering app'),
			});
		}
	};
};
